export default __webpack_public_path__ + "static/media/Logo_Git.7d664489.png";